import React, { Fragment, useRef, useEffect } from "react";
import PropTypes from "prop-types";
//Containers
import Navigation from "../Navigation";
//Pages Navigation
import { withRouter } from "react-router-dom";
import Router from "../../routes/Router";
//Styles
import GlobalStyle from "../../services/GlobalStyle";

//import { Footer, AlertBar } from "../../components/organisms";
//import { ScreenReaderText, Text, Link, Icon } from "../../components/atoms";
import { Footer } from "../../components/organisms";
import { Link } from "../../components/atoms";
import { AlertBar, ScreenReaderText, Text, Icon } from "@uaveiro/ui";
import { SEO } from "../../templates";
import Portal from "../Portal";
// Utils
import data from "../../data/footer";
import { StoreContext } from "../../context/StoreContext";
import { compose, isIE } from "../../services/utilities";
import { lang, changeLanguage } from "../../translations";
import { withTheme } from "styled-components";

function App({ location, history, theme }) {
  const content = useRef(null);
  const goUpButton = useRef(null);

  useEffect(() => {
    const pathLang = location.pathname.search(lang());
    const langValue = lang() === "pt" ? "en" : "pt";

    if (typeof window !== "undefined") {
      const domainUrl = window.location.href;

      if (!domainUrl.includes("login") && !domainUrl.includes("404")) {
        localStorage.setItem("portalLastLocationPath", location.pathname);
      }

      if (!domainUrl.includes("#gsc.tab") && domainUrl.includes("#")) {
        window.location.replace(domainUrl.replace("/#", ""));
      }

      if (location.pathname.includes("styles")) {
        history.push(`/pt/404`);
      }

      //not a supported language
      if (location.pathname !== "/") {
        if (
          !location.pathname.includes("pt/") &&
          !location.pathname.includes("en/")
        ) {
          history.replace(`${lang()}${location.pathname}`);
        }
      }
    }

    //change language based on url pathname
    if (location.pathname !== "/") {
      if (pathLang === -1) {
        changeLanguage(langValue);
      }
    }
    content.current.focus();
  }, [location.pathname]);

  /*
  -- Scroll To Top
  */

  const checkPosition = () => {
    let windowY = window.scrollY;
    if (windowY >= 155) {
      // Scrolled more than 1536px
      goUpButton.current.classList.add("visible");
      goUpButton.current.classList.remove("hidden");
    } else {
      // Scrolled less than 1536px
      goUpButton.current.classList.add("hidden");
      goUpButton.current.classList.remove("visible");
    }
  };

  useEffect(() => {
    window.addEventListener("scroll", checkPosition);
    return () => {
      window.removeEventListener("scroll", checkPosition);
    };
  }, []);

  const backToTop = () => {
    window.scrollTo(0, 0);
  };

  return (
    <Fragment>
      <SEO />
      {location.pathname === "/" && (
        <ScreenReaderText>
          <h1>Página inicial</h1>
        </ScreenReaderText>
      )}
      <div>
        {/*isIE() && (
          <AlertBar backgroundColor="#d32f2f" noAnimation hasAction={true}>
            <Text fontSize="12px" color="#fff">
              Não é recomendada a navegação no novo Portal da UA com o Internet
              Explorer. &nbsp;
              <Link
                textDecoration="underline"
                href="https://static.ua.pt/browser-support/"
                target="_blank"
                fontSize="12px"
                color="#fff"
                native
              >
                Veja as nossas sugestões.
              </Link>
            </Text>
          </AlertBar>
        )*/}

        <Navigation />
        <div>
          <span tabIndex="-1" ref={content} />
          <Router />
        </div>
      </div>
      <Footer key="footer" {...data.footer} />

      {process.env.RAZZLE_TOGGLE_CHATBOT == "true" ? (
        <link-chatbot-widget style={{ position: "absolute" }} />
      ) : (
        ""
      )}

      <StoreContext.Consumer>
        {store => (
          <GlobalStyle
            zoom={store.state.zoomValue}
            filter={store.state.accessibilityValue}
          />
        )}
      </StoreContext.Consumer>

      {/*Back to top*/}
      {typeof window !== "undefined" && (
        <Portal>
          <button
            ref={goUpButton}
            className="go-to-top hidden"
            onClick={backToTop}
            title="Go to top"
          >
            <Icon
              name={theme.icons.arrow_up}
              color={theme.components.goToTopButton.iconColor}
              size="small"
            />
          </button>
        </Portal>
      )}
    </Fragment>
  );
}

App.propTypes = {
  location: PropTypes.object.isRequired,
  history: PropTypes.object.isRequired
};

export default compose(withRouter, withTheme)(App);
